<footer class="border-t border-ink/8 bg-snow">
  <div
    class="mx-auto flex max-w-6xl flex-col gap-6 px-5 py-12 md:flex-row md:items-center md:justify-between"
  >
    <p class="text-[13px] font-semibold tracking-[0.18em] text-ink">GIVE SANTA</p>
    <div class="space-y-3">
      <nav aria-label="Footer" class="flex flex-wrap gap-x-6 gap-y-2 text-sm text-mute">
        <a routerLink="/" fragment="how">How It Works</a>
        <a routerLink="/faq">FAQ</a>
        <a routerLink="/about">About</a>
        <a routerLink="/contact">Contact</a>
      </nav>
      <nav aria-label="Legal" class="flex flex-wrap gap-x-6 gap-y-2 text-xs text-mute/75">
        <a routerLink="/privacy">Privacy Policy</a>
        <a routerLink="/terms">Terms &amp; Conditions</a>
      </nav>
    </div>
    <p class="text-xs text-mute">© {{ year }} Give Santa</p>
  </div>
</footer>
